export const VisitorActionTypes = {
    LOGOUT: 'LOGOUT',

    COMMON_ERROR: 'COMMON_ERROR',

    ADD_VISITOR_RECORD_REQUEST: 'ADD_VISITOR_RECORD_REQUEST',
    ADD_VISITOR_RECORD_REQUEST_SUCCESS: 'ADD_VISITOR_RECORD_REQUEST_SUCCESS',
    ADD_VISITOR_RECORD_REQUEST_ERROR: 'ADD_VISITOR_RECORD_REQUEST_ERROR',
    ADD_VISITOR_RECORD_REQUEST_STATUS: 'ADD_VISITOR_RECORD_REQUEST_STATUS',

    VISITOR_LIST_REQUEST: 'VISITOR_LIST_REQUEST',
    VISITOR_LIST_REQUEST_SUCCESS: 'VISITOR_LIST_REQUEST_SUCCESS',
    VISITOR_LIST_REQUEST_ERROR: 'VISITOR_LIST_REQUEST_ERROR',

    VISITOR_UPDATE_CONFIGURATION_REQUEST: 'VISITOR_UPDATE_CONFIGURATION_REQUEST',
    VISITOR_UPDATE_CONFIGURATION_REQUEST_SUCCESS: 'VISITOR_UPDATE_CONFIGURATION_REQUEST_SUCCESS',
    VISITOR_UPDATE_CONFIGURATION_REQUEST_ERROR: 'VISITOR_UPDATE_CONFIGURATION_REQUEST_ERROR',
    VISITOR_UPDATE_CONFIGURATION_REQUEST_STATUS: 'VISITOR_UPDATE_CONFIGURATION_REQUEST_STATUS',

    VISITOR_GET_CONFIGURATION_REQUEST: 'VISITOR_GET_CONFIGURATION_REQUEST',
    VISITOR_GET_CONFIGURATION_REQUEST_SUCCESS: 'VISITOR_GET_CONFIGURATION_REQUEST_SUCCESS',
    VISITOR_GET_CONFIGURATION_REQUEST_ERROR: 'VISITOR_GET_CONFIGURATION_REQUEST_ERROR',

    VISITOR_MARK_EXIT_REQUEST: 'VISITOR_MARK_EXIT_REQUEST',
    VISITOR_MARK_EXIT_REQUEST_SUCCESS: 'VISITOR_MARK_EXIT_REQUEST_SUCCESS',
    VISITOR_MARK_EXIT_REQUEST_ERROR: 'VISITOR_MARK_EXIT_REQUEST_ERROR',
    VISITOR_MARK_EXIT_REQUEST_STATUS: 'VISITOR_MARK_EXIT_REQUEST_STATUS'
}
